import { SxProps } from "@mui/material";

export const paperSx: SxProps = { p: "0 20px 20px 20px" };
export const gridHeadSx: SxProps = { mb: "30px", flexDirection: "column", alignItems: "baseline" };
export const buttonSx: SxProps = { mt: "10px" };
